"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intersectArrays = intersectArrays;
exports.groupBy = groupBy;
exports.haveFiltersChanged = haveFiltersChanged;
function intersectArrays(...arrs) {
    let intersection = arrs.pop() || [];
    while (arrs.length) {
        const compare = arrs.pop();
        intersection = intersection.filter((each) => compare.includes(each));
    }
    return intersection;
}
function groupBy(list, keyGetter) {
    const obj = {};
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = obj[key];
        if (!collection) {
            obj[key] = [item];
        }
        else {
            collection.push(item);
        }
    });
    return obj;
}
function haveFiltersChanged(a, b) {
    return (a.length !== b.length ||
        a.some((filterA) => !b.some((filterB) => filterB.type === filterA.type && filterB.value === filterA.value)));
}
//# sourceMappingURL=array.util.js.map